module.exports = __webpack_public_path__ + "static/media/company-placeholder.40b44d14.png";